import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode';
import LoadingOverlay from './LoadingOverlay';
import './InterviewConfig.css';

const InterviewConfig = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedDifficulty, setSelectedDifficulty] = useState('');
  const [selectedQuestionType, setSelectedQuestionType] = useState('');
  const [selectedIndustry, setSelectedIndustry] = useState('');
  const [selectedCaseType, setSelectedCaseType] = useState('');
  const [selectedInterviewStyle, setSelectedInterviewStyle] = useState('');

  // Options for each category
  const difficultyOptions = ['Easy', 'Medium', 'Hard'];
  const questionTypeOptions = ['Business Case', 'Maths Question'];
  const industryOptions = [
    'Technology', 
    'Healthcare', 
    'Finance', 
    'Retail', 
    'Manufacturing', 
    'Energy',
    'Insurance',
    'Consulting',
    'Transportation',
    'Media & Entertainment'
  ];
  const caseTypeOptions = [
    'Market Sizing',
    'Market Entry',
    'Pricing Strategy',
    'Growth Strategy',
    'Cost Reduction',
    'Merger & Acquisition',
    'Product Launch',
    'Profitability Analysis',
    'Competitive Response',
    'Operations'
  ];
  const interviewStyleOptions = ['Interviewer-led', 'Interviewee-led'];

  const handleDifficultySelect = (e, difficulty) => {
    e.preventDefault();
    setSelectedDifficulty(difficulty);
  };

  const handleQuestionTypeSelect = (e, questionType) => {
    e.preventDefault();
    setSelectedQuestionType(questionType);
  };

  const handleIndustrySelect = (e, industry) => {
    e.preventDefault();
    setSelectedIndustry(industry);
  };

  const handleCaseTypeSelect = (e, caseType) => {
    e.preventDefault();
    setSelectedCaseType(caseType);
  };

  const handleInterviewStyleSelect = (e, style) => {
    e.preventDefault();
    setSelectedInterviewStyle(style);
  };

  const handleRandomSelect = (e) => {
    e.preventDefault();
    // Randomly select options for each category
    setSelectedDifficulty(difficultyOptions[Math.floor(Math.random() * difficultyOptions.length)]);
    setSelectedQuestionType(questionTypeOptions[Math.floor(Math.random() * questionTypeOptions.length)]);
    setSelectedIndustry(industryOptions[Math.floor(Math.random() * industryOptions.length)]);
    setSelectedCaseType(caseTypeOptions[Math.floor(Math.random() * caseTypeOptions.length)]);
    setSelectedInterviewStyle(interviewStyleOptions[Math.floor(Math.random() * interviewStyleOptions.length)]);
  };

  const handleStartInterview = async (e) => {
   e.preventDefault();

   navigate('/chatbot');
  };

  return (
    <div className="interview-config">
      <h2>Configure Your Case Interview</h2>
      
      <div className="random-section">
        <button 
          className="random-button"
          onClick={handleRandomSelect}
        >
          <i className="fas fa-random"></i> Totally Random
        </button>
        <p className="random-description">Click to randomly select all options</p>
      </div>
      
      {/* Difficulty Selection */}
      <div className="config-section">
        <h3>1. Select Difficulty</h3>
        <div className="button-group">
          {difficultyOptions.map((difficulty) => (
            <button
              key={difficulty}
              type="button"
              className={`config-button ${selectedDifficulty === difficulty ? 'selected' : ''}`}
              onClick={(e) => handleDifficultySelect(e, difficulty)}
            >
              {difficulty}
            </button>
          ))}
        </div>
      </div>

      {/* Question Type Selection */}
      <div className="config-section">
        <h3>2. Select Question Type</h3>
        <div className="button-group">
          {questionTypeOptions.map((questionType) => (
            <button
              key={questionType}
              type="button"
              className={`config-button ${selectedQuestionType === questionType ? 'selected' : ''}`}
              onClick={(e) => handleQuestionTypeSelect(e, questionType)}
            >
              {questionType}
            </button>
          ))}
        </div>
      </div>

      {/* Industry Selection */}
      <div className="config-section">
        <h3>3. Select Industry</h3>
        <div className="button-group">
          {industryOptions.map((industry) => (
            <button
              key={industry}
              type="button"
              className={`config-button ${selectedIndustry === industry ? 'selected' : ''}`}
              onClick={(e) => handleIndustrySelect(e, industry)}
            >
              {industry}
            </button>
          ))}
        </div>
      </div>

      {/* Case Type Selection */}
      <div className="config-section">
        <h3>4. Select Case Type</h3>
        <div className="button-group">
          {caseTypeOptions.map((caseType) => (
            <button
              key={caseType}
              type="button"
              className={`config-button ${selectedCaseType === caseType ? 'selected' : ''}`}
              onClick={(e) => handleCaseTypeSelect(e, caseType)}
            >
              {caseType}
            </button>
          ))}
        </div>
      </div>

      {/* Interview Style Selection */}
      <div className="config-section">
        <h3>5. Select Interview Style</h3>
        <div className="button-group">
          {interviewStyleOptions.map((style) => (
            <button
              key={style}
              type="button"
              className={`config-button ${selectedInterviewStyle === style ? 'selected' : ''}`}
              onClick={(e) => handleInterviewStyleSelect(e, style)}
            >
              {style}
            </button>
          ))}
        </div>
      </div>

      {/* Start Button */}
      <div className="start-section">
        <button 
          className="start-button"
          onClick={handleStartInterview}
          disabled={!selectedDifficulty || !selectedQuestionType || !selectedIndustry || !selectedCaseType || !selectedInterviewStyle}
        >
          Start Interview
        </button>
      </div>

      {/* Error Message */}
      {error && <div className="error-message">{error}</div>}
      
      {/* Loading Overlay */}
      {loading && <LoadingOverlay message="Setting up your interview..." />}
    </div>
  );
};

export default InterviewConfig; 
